// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"eced189e","845":"cd30c422"}[chunkId] + ".chunk.js";
};